/* Shared formatters. Currency is EUR throughout Invoo (see inventory). */
export function formatCurrency(amount, currency = 'EUR', locale = 'fr-BE') {
  const n = Number(amount)
  if (Number.isNaN(n)) return '—'
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(n)
}

export function formatDate(value, locale = 'fr-BE') {
  if (!value) return '—'
  const d = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(d.getTime())) return '—'
  return new Intl.DateTimeFormat(locale, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(d)
}
